import { Space } from 'antd';
import { ColumnType } from '@/types';
import { DeleteButton } from '@/components/buttons/delete';
import { DeleteOutlined } from '@ant-design/icons';

export const getColumnsAdminEmail = (
  translate: (key: string) => string,
  handleDeleteEmail: () => void,
  setEmailToDelete: (email: string) => void,
  adminType?: string
): ColumnType[] => [
  {
    title: translate('system-config.contact-us.id'),
    key: 'id',
    dataIndex: 'id',
    render: (_, record, index) => index + 1,
  },
  {
    title: translate('system-config.contact-us.email'),
    dataIndex: 'admins_email',
    key: 'admins_email',
    render: (_, record) => record,
  },
  ...(adminType === 'SUPER_ADMIN'
    ? [
        {
          title: translate('system-config.contact-us.actions'),
          dataIndex: 'actions',
          key: 'actions',
          //@ts-ignore
          render: (_, record) => (
            <Space>
              <DeleteButton
                icon={<DeleteOutlined />}
                hideText
                size="small"
                recordItemId={record.id}
                confirmTitle={translate(
                  'system-config.contact-us.delete-confirm'
                )}
                onClick={() => setEmailToDelete(record)}
                onConfirm={() => handleDeleteEmail()}
              />
            </Space>
          ),
        },
      ]
    : []),
];
